export default {
  path: '/lvy-vip-ail-pay-subscription',
  component: () => import('./VipAilPaySubscription'),
  meta: {
    title: '会员订阅服务协议',
    designWidth: 750,
    expireIn: '',
    axiosConfig: {
      baseURL: '',
      withCredentials: false,
      postContentType: 'JSON'
    }
  }
}